const crossfadeDurationMs = 150;
const wrapper = "_35sw1e0bdlj";
const toggleGroup = "_35st1j4q6ux";
const transitionWrapper = "_35st1b7231";
const content = "_35sc1gxygdp";

export { content, crossfadeDurationMs, toggleGroup, transitionWrapper, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
